import React from 'react';
import CasinoVisuals from './casinoVisuals';
import CasinoProducts from './casinoProducts';

export default function Casino ({CasinoVisualList, DataComList, Logined, Type, ActStatus, Label, popupDiv}) {
	return (
		<div>
			{CasinoVisualList && (
				<CasinoVisuals
					casinoVisual={CasinoVisualList.Content.Table}
					Type={Type}
				/>
			)}
			{DataComList &&
				DataComList.AthenaTemplate.CasinoProduct && (
					<CasinoProducts
						casinoProduct={DataComList.AthenaTemplate.CasinoProduct.Table}
						popupDiv={popupDiv}
						Logined={Logined}
						ActStatus={ActStatus}
						Label={Label}
					/>
			)}
		</div>
	);
}
